import React from 'react'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'

export default function DeviceLoadGroups({ enrollmentData }) {
  if (!enrollmentData) return null

  // Flatten the load_groups for the table
  const rows = enrollmentData.load_groups.map((lg) => ({
    device_type: enrollmentData.field,
    device_id: enrollmentData.device_id,
    load_group_identifier: lg.definition_identifier,
    description: lg.description,
    scope_tags: lg.scope_tags.join(', '),
    created: lg.created ? new Date(lg.created).toLocaleString() : '—',
    modified: lg.modified ? new Date(lg.modified).toLocaleString() : '—',
  }))

  return (
    <Grid container mt={4}>
      <Grid item xs={12}>
        <h6>Device Load Group Overview</h6>
      </Grid>

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Device Type</TableCell>
                <TableCell>Device ID</TableCell>
                <TableCell>Load Group Identifier</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Scope Tags</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Modified</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.device_type}</TableCell>
                  <TableCell>{row.device_id}</TableCell>
                  <TableCell>{row.load_group_identifier}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.scope_tags}</TableCell>
                  <TableCell>{row.created}</TableCell>
                  <TableCell>{row.modified}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  )
}
